import roles from '@/utils/roles'

let tabs = [
    {
        name: 'Identification',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'identification',
            name: 'manage-company-identification',
            component: () => import('./identification'),
            roles: [roles.admin, roles.inHouseDataEntry],
        },
    },
    {
        name: 'Entity Providers',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'providers',
            name: 'manage-company-providers',
            component: () => import('@/pages/manage/entity-providers/list'),
            props: route => ({ entityType: 'Company', entityId: parseInt(route.params.companyId) }),
        },
    },
    {
        name: 'Evasion',

        options: {
            exact: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.aiAdmin, roles.salesAdmin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'evasion',
            name: 'manage-company-evasion',
            component: () => import('@/pages/manage/company/ManageCompanyEvasionPage/ManageCompanyEvasionPage.vue'),
            props: route => ({
                companyId: route.params.companyId,
            }),
        },
    },
    {
        name: 'Executives',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'executives',
            name: 'manage-company-executives',
            component: () => import('./ManageCompanyExecutives'),
            props: route => ({ companyId: parseInt(route.params.companyId) }),
        },
    },
    {
        name: 'Incentives',

        options: {
            exact: true,
            props: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry, roles.research, roles.salesAdmin],
            },
        },

        parent: {
            path: 'incentives',
            name: 'manage-company-incentives',
            component: () => import('./ManageCompanyIncentives.vue'),
            props: route => ({ companyId: parseInt(route.params.companyId) }),
        },
    },
    {
        name: 'Social Media',

        options: {
            exact: true,
            meta: {
                layout: 'app',
                roles: [roles.admin, roles.inHouseDataEntry],
            },
        },

        parent: {
            path: 'social-media',
            name: 'manage-company-social-media',
            component: () => import('@/pages/manage/social-media/list'),
            props: route => ({
                entityId: parseInt(route.params.companyId),
                entityType: 'company',
                addRoute: 'manage-company-social-media-add',
                editRoute: 'manage-company-social-media-edit',
            }),
        },

        children: [
            {
                path: 'add',
                name: 'manage-company-social-media-add',
                component: () => import('@/pages/manage/social-media/add'),
                props: route => ({
                    entityId: route.params.companyId,
                    entityType: 'company',
                    nextRoute: 'manage-company-social-media',
                }),
            },
            {
                path: 'edit',
                name: 'manage-company-social-media-edit',
                component: () => import('@/pages/manage/social-media/edit'),
                props: route => ({
                    entityId: route.params.companyId,
                    entityType: 'company',
                    handleId: route.params.handleId,
                    nextRoute: 'manage-company-social-media',
                }),
            },
        ],
    },
]

export default tabs
